import React, { useEffect, useRef } from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import "./SideBar.css";
import { Button } from "@progress/kendo-react-buttons";
import { BiChevronRight, BiChevronLeft } from "react-icons/bi";
import Layers from "./layers/Layers";
import { useSelector, useDispatch } from "react-redux";
import Options from "./Options";
import Results from "./Results/Results";
import {
    setSideBarOpen,
    setActiveSideBarTab,
    setDataGrid,
} from "../../redux/toolSelectSlice";

const SideBar = () => {
    const selected = useSelector((state) => state.toolSelect.sideBarTab);
    const activeTool = useSelector((state) => state.toolSelect.tool);
    const sideBarOpen = useSelector((state) => state.toolSelect.sideBarOpen);
    const bufferOptions = useSelector((state) => state.identifyOptions);
    const results = useSelector((state) => state.resultsData.results);
    const firstRender = useRef(true);
    const dispatch = useDispatch();
    const featuresToBuffer = useSelector(
        (state) => state.identifyOptions.featuresToBuffer
    );
    const dataGridOn = useSelector((state) => state.toolSelect.dataGrid);

    const handleSelect = (e) => {
        dispatch(setActiveSideBarTab(e.selected));
    };

    // Open sidebar to results when results is populated
    //  active tool may already be identify, but if it isn't then it is set to identify
    useEffect(() => {
        if (results.length > 0 && sideBarOpen === false && dataGridOn === false) {
            dispatch(setSideBarOpen(true));
            dispatch(setActiveSideBarTab(2));
        } else if (results.length > 0) {
            dispatch(setActiveSideBarTab(2));
        }
    }, [results]);

    // Open to list view when data grid is turned off, only if there are still results
    useEffect(() => {
        if (dataGridOn) return;
        if (firstRender.current === true) return;
        if (results.length > 0) {
            dispatch(setSideBarOpen(true));
            dispatch(setActiveSideBarTab(2));
        }
    }, [dataGridOn]);

    // Open options when user selects the option to buffer feature(s)
    useEffect(() => {
        if (selected !== 1 && featuresToBuffer.length > 0) {
            dispatch(setActiveSideBarTab(1));
        }
    }, [featuresToBuffer]);

    // handle active tool change
    // perform updates accordingly
    useEffect(() => {
        if (activeTool === "measure") {
            // open option
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "bookmarks") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "markup") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "print") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "identify") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "reports") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "query") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "edit") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "reports") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "addLayer") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "editrelatedrecord") {
            dispatch(setActiveSideBarTab(1));
        } else if (activeTool === "plotCoordinates") {
            dispatch(setActiveSideBarTab(1));
        } else {
            if (results.length > 0) {
                dispatch(setActiveSideBarTab(2));
            } else {
                dispatch(setActiveSideBarTab(0));
            }
        }
    }, [activeTool]);

    // open options when identify "more options" is selected
    useEffect(() => {
        if (bufferOptions.open === true) {
            // open options tab
            // viewing buffer options still needs to be set in Options.js
            dispatch(setActiveSideBarTab(1));
        }
    }, [bufferOptions.open]);

    // Close data grid when all results are removed
    useEffect(() => {
        if (results.length === 0 && dataGridOn) {
            dispatch(setDataGrid(false));
        }
    }, [results]);

    // Open sidebar and set selected tool to identify when
    //  results is populated from search
    useEffect(() => {
        if (results.length > 0 && sideBarOpen === false && dataGridOn === false) {
            dispatch(setSideBarOpen(true));
            dispatch(setActiveSideBarTab(2));
        }
    }, [results]);

    useEffect(() => {
        if (firstRender.current === true) {
            firstRender.current = false;
        }
    }, []);

    return (
        <div className={`panel-wrapper ${sideBarOpen ? "" : "closed"}`}>
            <TabStrip
                className={`panel ${sideBarOpen ? "" : "closed"}`}
                selected={selected}
                keepTabsMounted={true}
                onSelect={handleSelect}>
                <TabStripTab title="Layers">
                    <Layers className="layers" />
                </TabStripTab>
                <TabStripTab title="Options">
                    <Options />
                </TabStripTab>
                <TabStripTab title="Results">
                    <Results />
                </TabStripTab>
            </TabStrip>
            <Button
                title="Toggle Layers"
                className={`drawer-toggle`}
                onClick={() => {
                    dispatch(setSideBarOpen(!sideBarOpen));
                }}>
                {sideBarOpen ? <BiChevronLeft /> : <BiChevronRight />}
            </Button>
        </div>
    );
};

export default SideBar;
